import React, {useEffect, useMemo, useState} from "react";
import {useForm} from "react-hook-form";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {AziendaEditorProps} from "../Azienda.generalita.page";
import FormButtons from "../../../components/FormButtons";
import CheckboxEx from "../../../components/wrapperComponents/CheckboxEx";
import InputEx from "../../../components/wrapperComponents/InputEx";
import {useGetVociTicketQuery} from "@commons/features/azienda/tabelle/aziendaMapping.api";
import {ComboBoxVoceTk} from "../../../components/comboBox/ComboBoxInquadramento";


const VarieEditor: React.FC<AziendaEditorProps> = ({defaultValues, resource, onSubmit, onCancel}) => {
    const {watch, register, getValues, setValue, handleSubmit, reset, control, formState: {errors}} = useForm<AziendaRecord>();

    const initialValues: AziendaRecord = useMemo(() => {
        return {
            ...defaultValues, ...resource,
        };
    }, [resource, defaultValues]);

    useEffect(() => {
        reset(initialValues);
    }, [resource]);

    function onHandleSubmit(newValues: AziendaRecord) {
        onSubmit({
            ...newValues,
        })
    }

    const {data: dataVociTk, isLoading: isLoadingVociTk} = useGetVociTicketQuery({idDominio: resource.idDominio, idTabellaCosti: 1});
    const [voceTicket, setVoceTicket] = useState<number>(0);

    return <>

        <form className="p-1" onSubmit={handleSubmit(onHandleSubmit)}>

            <div className="flexRowWrapFull">
                <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                    <legend className="px-2">Varie</legend>

                    <div className="smFullP self-center">
                        <CheckboxEx label="Genera variazioni RML" control={control} name="generaVariazioniRML" className="h-full min-w-[30px] max-w-[30px]"/>
                    </div>
                    <div className="sm1-2P">
                        <InputEx name="spaccaturaElab" id="spaccaturaElab" label="Spaccatura elaborazioni"
                                 maxLength={30} placeholder="A-L;M-Z" register={register}/>
                    </div>
                </fieldset>

                <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                    <legend className="px-2">Ticket Restaurant</legend>
                    <div className="sm1-2P">
                        <InputEx name="ticketR.codAzienda" id="ticketCodAz" label="Codice azienda" type="text" register={register}/>
                    </div>
                    <div className="sm1-2P pr-0">
                        <InputEx name="ticketR.codUL" id="ticketCodUL" label="Codice UL" type="text" register={register}/>
                    </div>
                    <div className="sm1-3P">
                        <InputEx name="puntoConsegnaTicketR" id="puntoDiCons" label="Denominazione punto di consegna" type="text"
                                 maxLength={30} register={register}/>
                    </div>
                    <div className="sm1-3P">
                        <InputEx name="valoreUnitarioTicketR" id="valUnitario" label="Valore unitario ticket" type="number" register={register}/>
                    </div>
                    <div className="sm1-3P">
                        <ComboBoxVoceTk label="Voce ticket" name="pva.voceTicket" data={dataVociTk} isLoading={isLoadingVociTk} control={control}
                                        defaultValue={defaultValues.pva.voceTicket} disabled={!AziendaRecord.isMaster(resource)}/>
                    </div>
                </fieldset>
            </div>
            <FormButtons onCancel={onCancel} resource={resource}/>

        </form>

    </>
}
export default VarieEditor;
